import { __, compose, repeat } from 'lodash/fp';
import styled from 'styled-components';
import { Component as ReactComponent } from 'react';
import { Field } from '@optimus-web/core';

const PaymentInputContainer = (component: React.ComponentType) => styled(component)`
    height: 38px;
    width: 100%;
`;

const repeatAsterisk = repeat(__, '*');

const PciProxyField = (Component: $TSFixMe) =>
    class extends ReactComponent {
        handleMetadataChange = (metadata: $TSFixMe) => {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if ((this.props as $TSFixMe).onMetadataChange) {
                (this.props as $TSFixMe).onMetadataChange(metadata);
            }

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if ((this.props as $TSFixMe).onChange) {
                const fakeValue = repeatAsterisk(metadata.length);
                (this.props as $TSFixMe).onChange(null, fakeValue);
            }
        };

        handleBlur = (metadata: $TSFixMe) => {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if ((this.props as $TSFixMe).onMetadataChange) {
                (this.props as $TSFixMe).onMetadataChange(metadata);
            }

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if ((this.props as $TSFixMe).onBlur) {
                const fakeValue = repeatAsterisk(metadata.length);
                (this.props as $TSFixMe).onBlur(null, fakeValue);
            }
        };

        render() {
            const props = {
                ...this.props,
                onBlur: this.handleBlur,
                onMetadataChange: this.handleMetadataChange,
            };

            return <Component {...props} />;
        }
    };

export const createPciProxyField = compose(Field, PciProxyField, PaymentInputContainer);
